import React from "react"
import styled from "styled-components"

import { useMenu } from "../../data/hooks/menu";
import * as PropTypes from "prop-types";
import {InternalLink} from "../../style/itf-styled-components";

const MenuItem = styled(InternalLink)`
  border-bottom: transparent 2px solid;
  color: ${props => props.theme.colors.neutrals._800};
  font-size: 1.000em;
  padding: 0.625em 0.750em;
  white-space: nowrap;
  margin: 0 5px;
  
  :hover {
    border-bottom: ${props => props.theme.colors.primary._500} 2px solid;
  }
`;

const ActiveMenuItem = styled(MenuItem)`
  border-bottom: ${props => props.theme.colors.primary._500} 2px solid;
  
  :hover {
    background-color: inherit;
    border-radius: 0;
  }
`;

const MenuItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  
  ::after {
    position: absolute;
  }
`;

const TicketsMenuItemWrapper = styled(MenuItemWrapper)`
  border: 2px solid #ff72f6;

  ::after {
    background-color: #ff72f6;
    color: #ffffff;
    border: 2px solid #ff72f6;
    left: -2px;
    bottom: -22px;
    box-sizing: content-box;
    line-height: 21px;
    content: 'Early Bird';
    font-size: 0.70em;
    width: 100%;
    text-align: center;
    height: 21px;
  }
`;

const Container = styled.div`
  padding: 1.250em 1.250em 1.250em 0;
`;

const Menu = ({ className, page }) => {
  const menuItems = useMenu();

  return (
    <Container className={className}>
      {menuItems.map((item, _) => (
        page === item.page
          ? (
            <ActiveMenuItem
              key={item.page}
              to={item.link}
            >{item.label}</ActiveMenuItem>
          )
          : (
            <MenuItem
              key={item.page}
              to={item.link}
              title={item.label}
            >
              <span>{item.label}</span>
            </MenuItem>
          )
      )).map((menuItem) => (
        menuItem.key === 'tickets'
          ? (<TicketsMenuItemWrapper key={menuItem.key}>{menuItem}</TicketsMenuItemWrapper>)
          : (<MenuItemWrapper key={menuItem.key}>{menuItem}</MenuItemWrapper>)
      ))}
    </Container>
  );
};

Menu.propTypes = {
  page: PropTypes.string
};

export default Menu
